// src/features/media/components/VideoMetadataCard.tsx

import { Card, Stack, Group, Text, ThemeIcon } from '@mantine/core';
import { IconClock, IconCalendar, IconFile } from '@tabler/icons-react';
import { MediaStatusType } from '@lib2/model/media/MediaTypes';
import { MediaUtils } from '../MediaUtils';
import { MediaStatusBadge } from './MediaStatusBadge';
import { formatTimestamp } from '@/shared/utils/date';
import type { VideoViewData } from '@/lib/types/Media';

interface VideoMetadataCardProps {
  video: VideoViewData;
}

export function VideoMetadataCard({ video }: VideoMetadataCardProps) {
  const media = video.media;
  const totalSize = MediaUtils.getTotalFileSize(video.files);

  return (
    <Card shadow="sm" withBorder h="100%">
      <Stack gap="md">
        <Group gap="sm">
          <Text size="sm" fw={500} c="dimmed">Status</Text>
          <MediaStatusBadge status={media.mediaStatusType} state={media.mediaStateType} />
        </Group>

        {media.duration > 0 && (
          <Group gap="sm">
            <ThemeIcon variant="light" size="sm">
              <IconClock size={14} />
            </ThemeIcon>
            <Text size="sm">Duration: {MediaUtils.formatDuration(media.duration)}</Text>
          </Group>
        )}

        <Group gap="sm">
          <ThemeIcon variant="light" size="sm">
            <IconCalendar size={14} />
          </ThemeIcon>
          <Text size="sm">Created: {formatTimestamp(media.created)}</Text>
        </Group>

        <Group gap="sm">
          <ThemeIcon variant="light" size="sm">
            <IconCalendar size={14} />
          </ThemeIcon>
          <Text size="sm">Updated: {formatTimestamp(media.updated)}</Text>
        </Group>

        {totalSize > 0 && (
          <Group gap="sm">
            <ThemeIcon variant="light" size="sm">
              <IconFile size={14} />
            </ThemeIcon>
            <Text size="sm">Size: {MediaUtils.formatFileSize(totalSize)}</Text>
          </Group>
        )}
      </Stack>
    </Card>
  );
}
